import styles from "../../styles/shared/ai-trade-suggestion/AnalysisInfo.module.css";
import { FaLightbulb } from "react-icons/fa";
import useSuggestedSignal from "../../hooks/useSuggestedSignal";
import { message, Skeleton, Tooltip } from "antd";
import { FaArrowTrendDown, FaArrowTrendUp } from "react-icons/fa6";
import { AiFillClockCircle } from "react-icons/ai";
import { IoCopyOutline } from "react-icons/io5";
import { HiPresentationChartLine } from "react-icons/hi2";

const CopyableValue = ({ value, children }) => {
  const copyValue = () => {
    navigator?.clipboard
      ?.writeText(value)
      .then(() => {
        return message.success("Copied!");
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  };

  return (
    <div onClick={copyValue} style={{ width: "fit-content" }}>
      <Tooltip
        title="Click to copy"
        className={`${styles.value} ${styles.tooltip}`}
        color="#0f1c53"
        trigger="hover"
      >
        {children} <IoCopyOutline />
      </Tooltip>
    </div>
  );
};

function AnalysisInfo({ coin, timeframe, loading = false }) {
  const {
    signal,
    signalColor,
    stopLoss,
    takeProfit,
    positionSize,
    signalDate,
    liveSuggestionLoading,
  } = useSuggestedSignal({
    coin,
    timeframe,
    oppositeSignal: "",
  });

  const showLoading = loading || liveSuggestionLoading;
  const suggestionText = signal?.trim();

  return (
    <div className={styles.infoList}>
      <div className={`${styles.infoItem} ${styles.suggestion}`}>
        <div className={styles.infoIcon}>
          <FaLightbulb size={18} color="#0c4cfc" />
        </div>
        <div className={styles.info}>
          <span className={styles.label}>Suggestion</span>
          {showLoading ? (
            <Skeleton.Button active size="small" className={styles.loader} />
          ) : (
            <span style={{ color: signalColor }} className={styles.value}>
              {suggestionText || "-"}
            </span>
          )}
        </div>
      </div>

      <div className={styles.infoItem}>
        <div className={styles.infoIcon}>
          <FaArrowTrendDown size={18} color="#0c4cfc" />
        </div>
        <div className={styles.info}>
          <span className={styles.label}>Stop Loss</span>
          {showLoading ? (
            <Skeleton.Button active size="small" className={styles.loader} />
          ) : stopLoss ? (
            <CopyableValue value={stopLoss}>
              {Number(stopLoss)?.toFixed(2)}%
            </CopyableValue>
          ) : (
            "-"
          )}
        </div>
      </div>

      <div className={styles.infoItem}>
        <div className={styles.infoIcon}>
          <FaArrowTrendUp size={18} color="#0c4cfc" />
        </div>
        <div className={styles.info}>
          <span className={styles.label}>Take Profit</span>
          {showLoading ? (
            <Skeleton.Button active size="small" className={styles.loader} />
          ) : takeProfit ? (
            <CopyableValue value={takeProfit}>
              {Number(takeProfit)?.toFixed(2)}%
            </CopyableValue>
          ) : (
            "-"
          )}
        </div>
      </div>

      <div className={styles.infoItem}>
        <div className={styles.infoIcon}>
          <HiPresentationChartLine size={18} color="#0c4cfc" />
        </div>
        <div className={styles.info}>
          <span className={styles.label}>Position Size</span>
          {showLoading ? (
            <Skeleton.Button active size="small" className={styles.loader} />
          ) : positionSize ? (
            <CopyableValue value={Number(positionSize)?.toFixed(2)}>
              {Math.trunc(Number(positionSize))}%
            </CopyableValue>
          ) : (
            "-"
          )}
        </div>
      </div>

      <div className={styles.infoItem}>
        <div className={styles.infoIcon}>
          <AiFillClockCircle size={18} color="#0c4cfc" />
        </div>
        <div className={styles.info}>
          <span className={styles.label}>Last Updated</span>
          {showLoading ? (
            <Skeleton.Button active size="small" className={styles.loader} />
          ) : signalDate ? (
            <span className={styles.value}>{signalDate}</span>
          ) : (
            "-"
          )}
        </div>
      </div>
    </div>
  );
}

export default AnalysisInfo;
